import replacePlaceholders from './../helpers/__base/replacePlaceholders';
import upperCaseFirstLetter from './../helpers/__base/upperCaseFirstLetter';

export enum MessageType {
  Error = 'error',
  Success = 'success',
}

type RecordType = Record<string, any>;
type MethodMessagesType = RecordType;

export type EntityMethodsMessagesType = Record<string, MethodMessagesType>;
export type DeclensionsObj = Record<string, string>;
export type DeclensionInfo = string | DeclensionsObj;
export type EntityDeclensions = Record<string, DeclensionInfo>;

const declensionsFieldPlural = 'м';
const dynamicPlaceholderPrefix = ':';
const dynamicPlaceholderPrefixLength = dynamicPlaceholderPrefix.length;
const dynamicPlaceholderDeclensionPrefix =
  dynamicPlaceholderPrefix + 'declension';
const placeholderUpperCasePostfix = '.u';
const placeholderUpperCasePostfixLength = placeholderUpperCasePostfix.length;

/**
 * Get message for entity apiService method
 * @param {object} entityMethodsMessages - Methods messages
 * @param {string} methodName - Name of apiService method
 * @param {MessageType} messageType - Type for alerts (later: can be any string)
 * @param {object} entityDeclensions - Declensions for entity
 * @param {object} methodsDefaultMessages - Default messages
 */
export default function getEntityMethodMessage(
  entityMethodsMessages: EntityMethodsMessagesType,
  methodName: string,
  messageType: MessageType,
  methodsDefaultMessages: EntityMethodsMessagesType = { _: {} },
  entityDeclensions: EntityDeclensions = {
    [declensionsFieldPlural]: {},
  }
) {
  /* Extract message info */
  const methodMessageInfo = {
    ...methodsDefaultMessages._,
    ...(entityMethodsMessages[methodName] ||
      methodsDefaultMessages[methodName] ||
      {}),
  };
  const messagePattern = methodMessageInfo[messageType];
  /* Possible empty object */
  const declensions = (methodMessageInfo.isPlural
    ? entityDeclensions[declensionsFieldPlural]
    : entityDeclensions) as DeclensionsObj;
  return messagePattern
    ? replacePlaceholders(messagePattern, {}, placeholder => {
      /* Remove braces */
      const key = placeholder.slice(1, -1);

      /* Define target & it's field */
      let field: string;
      let target: DeclensionsObj;
      if (key.startsWith(dynamicPlaceholderDeclensionPrefix)) {
        field = methodMessageInfo[key.slice(dynamicPlaceholderPrefixLength)];
        target = declensions;
      } else {
        field = key;
        target = methodMessageInfo;
      }

      /* Text formatting */
      let value;
      if (key.endsWith(placeholderUpperCasePostfix)) {
        field = field.slice(0, -placeholderUpperCasePostfixLength);
        value = upperCaseFirstLetter(target[field]);
      } else {
        value = target[field]?.toLowerCase() || '';
      }

      return value;
    })
    : '';
}
